import api from 'api'

export type NotInterestedReason = {
  reason: string
  count: number
}

export type NotInterestedReasonsResponse = {
  listingId: number
  notInterestedReasons: NotInterestedReason[]
}

export async function getNotInterestedReasons(listingId: number) {
  const response = await api.get<NotInterestedReasonsResponse>(
    `/admin/listing/${listingId}/not_interested_reasons`
  )

  return response.data
}
